import type { Kit } from './instruments';

/** A built-in station's music: a tempo and what to play on each 16th-note step. */
export interface Style {
  bpm: number;
  /** Delay on off-beat 16ths, 0–0.3 of a step. */
  swing: number;
  /** step: 0–15 within the bar; bar counts up forever; time: when to play it. energy: 0–1, rises with speed. */
  play(kit: Kit, step: number, bar: number, time: number, stepLength: number, energy: number): void;
}

/** Chord for this bar from a looping progression. */
export function chordFor(progression: readonly (readonly number[])[], bar: number): readonly number[] {
  return progression[bar % progression.length] ?? progression[0] ?? [60];
}

export function hits(pattern: string, step: number): boolean {
  return pattern[step] === 'x';
}
